import { borderRadius } from 'react-select/src/theme';
import { provideSingleton } from '../../../services/inversify';
import { SectionStyle } from '../../../helpers/SectionStyle';

@provideSingleton(GetLayoutStyle)

export class GetLayoutStyle {
    styles() {
        const containerId: string = typeof SectionStyle.curPrintSectionId === 'number' ? SectionStyle.getCurrentClass(true) : null;
        const colorSection: string = new SectionStyle(containerId).getPropertyValue('--color-section-main');
        const fontFamily = 'Helvetica-Bold';
        // const fontFamily = 'Calibri-Bold';
        const styles = {
            mainWrapper: {
                width: '100%',
                height: '100%',
                display: 'flex',
                color: '#888',
                justifyContent: 'flex-start',
                flexDirection: 'column'
            },
            titleWrapper: {
                width: '100%',
                height: 60,
                top: 0,
                left: 0,
                padding: 0,
                position: 'relative',
                display: 'block'
            },
            titleImage: {
                width: 241,
                height: 40,
                top: 0,
                right: 0,
                position: 'absolute',
                display: 'inline-block'
            },
            titleImage2: {
                width: 'auto',
                height: 40,
                top: 0,
                right: 0,
                position: 'absolute',
                display: 'inline-block'
            },
            titleImage3: {
                maxWidth: 80,
                height: 40,
                objectFit: 'contain',
                top: 0,
                right: 70,
                position: 'absolute',
                display: 'inline-block'
            },
            titleFont: {
                fontSize: '18pt',
                fontFamily,
                color: '#555'
            },
            unternehmenFont: {
                fontSize: '14pt',
                fontFamily,
                color: colorSection || '#84b0d6'
            },
            titleFont2: {
                fontSize: '16pt',
                fontFamily,
                color: colorSection || '#5e8bc2',
                width: 450,
                overflow: 'hidden'
            },
            titleFont2Small: {
                fontSize: '14pt',
                fontFamily,
                color: colorSection || '#5e8bc2'
            },
            titleFont3: {
                fontSize: '11pt',
                fontFamily,
                color: '#555',
                marginTop: 10
            },
            titleFont4: {
                fontSize: '10pt',
                fontFamily,
                color: colorSection || '#6692c2'
            },
            w100: {
                width: '100%'
            }
        };
        return styles;
    }
}
